/**
 * Los contadores de atasco del flujo activo.  (FR-005)
 *
 * Un vistazo y ves por qué una conversación no avanza: "sin disponibilidad ×3"
 * es un bucle (el umbral de `looping` del bot). A partir de ahí, en ámbar.
 */
import type { Contadores } from '../lib/tipos'
import { Badge } from './ui/badge'

/** Igual que el clasificador del bot (domain/stuck.ts): 3 repeticiones = bucle. */
const UMBRAL_BUCLE = 3

const ETIQUETAS: { clave: keyof Contadores; corta: string }[] = [
    { clave: 'noAvailability', corta: 'sin hueco' },
    { clave: 'collision', corta: 'colisión' },
    { clave: 'modifyFail', corta: 'fallo modif.' },
]

export function CountersCell({ counters }: { counters: Contadores | null }) {
    if (!counters) return <span className="text-neutral-700">—</span>

    const visibles = ETIQUETAS.map(({ clave, corta }) => ({ corta, n: counters[clave] ?? 0 })).filter((c) => c.n > 0)
    if (visibles.length === 0) return <span className="text-neutral-700">—</span>

    return (
        <div className="flex flex-wrap gap-1">
            {visibles.map((c) => (
                <Badge key={c.corta} tone={c.n >= UMBRAL_BUCLE ? 'warning' : 'neutral'}>
                    {c.corta} ×{c.n}
                </Badge>
            ))}
        </div>
    )
}
